import { Link } from "react-router-dom";

const LOGO_SRC = `${process.env.PUBLIC_URL || ""}/calculator-logo.png`;

export default function CalculatorHeader({ title, otherLabel, otherTo }) {
  return (
    <div className="driver-top">
      <div className="driver-brand">
        <div className="driver-logo driver-logo--brand">
          <img src={LOGO_SRC} alt="The Table Top" />
        </div>
        <div>
          <div className="driver-title">{title}</div>
          <div className="driver-subtitle">The Table Top</div>
        </div>
      </div>
      <Link to={otherTo} className="driver-help-btn" style={{ background: "#EE2677" }}>
        {otherLabel}
      </Link>
    </div>
  );
}
